import React from 'react';
import { useElevenLabsTracking } from '../../utils/hooks/useElevenLabsTracking';

/**
 * Component that initializes ElevenLabs conversation tracking
 * This component doesn't render anything, it just sets up the tracking
 */
export const ElevenLabsTracker: React.FC<{ children?: React.ReactNode }> = ({ children }) => {
  // Initialize the tracking hook
  useElevenLabsTracking();

  // This component doesn't render anything visible
  return <>{children}</>;
};

export default ElevenLabsTracker;


